export default [
  'BOTMyFavorites'
]

/* Appears on /favorites */
